import SectionHeading from "@/components/base/SectionHeading";
import ArticleCard from "@/components/base/ArticleCard";
import { getFeaturedArticles, getLatestArticles } from "@/mocks/articles";

export default function FeaturedSection() {
  const featured = getFeaturedArticles();
  const [lead, ...rest] = featured;
  const more = getLatestArticles(9).filter(
    (item) => item.id !== lead?.id && !rest.some((entry) => entry.id === item.id),
  );

  if (!lead) return null;

  return (
    <section id="featured" className="mx-auto max-w-[1400px] px-4 py-16 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="HOT BREAKING"
        title="重磅爆料正在发酵"
        description="当天讨论度最高的大瓜，已把原帖、截图与时间线整理完毕，点开即看全过程。"
        linkTo="/category/baoliao"
        linkLabel="进入爆料栏目"
      />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <ArticleCard article={lead} variant="feature" />
        </div>
        <div className="flex flex-col gap-5 lg:col-span-5">
          {rest.slice(0, 2).map((article) => (
            <ArticleCard key={article.id} article={article} variant="default" />
          ))}
        </div>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {more.slice(0, 3).map((article) => (
          <ArticleCard key={article.id} article={article} variant="default" />
        ))}
      </div>
    </section>
  );
}